"use client";

import { Button } from "@/components/ui/button";
import Link from "next/link";
import { Typography } from "@/components/ui/typography";
import type { ServicesDocumentsProps } from "./types";
import { servicesDocumentsMap } from "./constants";
import { memo } from "react";
import { cn } from "@/lib/utils";
import { TranslationDeliverablesCardLink } from "@/components/screen/global-components/translation-deliverables";
import { ROUTES } from "@/constants";

const ServicesDocuments = ({
  variant = "certified",
  className,
}: ServicesDocumentsProps) => {
  const {
    cards,
    content: { title, description },
  } = servicesDocumentsMap[variant];

  return (
    <section
      className={cn("section bg-white lg:bg-background-secondary", className)}
    >
      <div className="container mx-auto py-12 lg:py-20">
        <div className="flex flex-col md:justify-center md:text-center gap-4 md:gap-2 md:w-full md:max-w-[746px] md:mx-auto">
          <Typography variant="heading4">
            <h2>{title}</h2>
          </Typography>
          <div className="flex justify-center text-gray-600">
            <Typography variant="subHeadingSm" asChild>
              <p>
                {description}
              </p>
            </Typography>
          </div>
        </div>
        <div className="mt-6 lg:mt-12">
          <div className="flex flex-wrap justify-center -m-2">
            {cards.map(({ href, imageUrl, title }, idx) => {
              return (
                <TranslationDeliverablesCardLink
                  key={idx}
                  href={href}
                  imageUrl={imageUrl}
                  imageAlt={title}
                  className="p-2 w-[50%] sm:w-[33.33%] md:w-[25%] lg:w-[20%] flex [&>a]:!pb-5"
                >
                  {title}
                </TranslationDeliverablesCardLink>
              );
            })}
          </div>
        </div>
        <div className="mt-6 lg:mt-12 text-center flex items-center justify-center">
          <Button
            asChild
            variant="primary-outline"
            className="py-3 px-6 h-[48px] w-full sm:w-auto"
          >
            <Link href={ROUTES.documentsAndDeliverables} className="!text-base">
              Explore documents
            </Link>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default memo(ServicesDocuments);
